"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = _react.default.createElement("svg", {
  width: "16",
  height: "13",
  viewBox: "0 0 16 13"
}, _react.default.createElement("path", {
  d: "M4.05 4.76C4.74 2.24 6.93 0 9.82 0A6.1 6.1 0 0116 6c0 3.33-2.78 6-6.18 6H3.9A3.86 3.86 0 010 8.2c0-1.06.46-2 1.27-2.62a4.35 4.35 0 012.78-.82zM9.82 1C7.36 1 5.4 3.03 4.92 5.38a.5.5 0 01-.53.4c-1.1-.1-1.94.16-2.51.6A2.24 2.24 0 001 8.2C1 9.74 2.29 11 3.9 11h5.92A5.1 5.1 0 0015 6c0-2.75-2.3-5-5.18-5z"
}));

exports.default = _default;